import DefaultData from './data/DefaultData';
export const defaultChartOptions = {
  title: {
    text: 'Lorem ipsum dolor sit amet',
  },
  subtitle: {
    text: 'consectetur adipiscing elit, sed do eiusmod',
  },
  plotOptions: {
    series: {
      states: {
        select: {
          color: '#EFFFEF',
          borderColor: 'black',
          dashStyle: 'dot',
        },
      },
      label: {
        enabled: false,
      },
    },
  },
  credits: {
    text: 'everviz.com',
    href: 'https://everviz.com',
  },
  lang: {
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
  },
  series: [
    {
      data: [],
      test: 1,
    },
  ],
  data: {
    csv: DefaultData.line.data,
    seriesMapping: DefaultData.line.seriesMapping,
  },
};

export const defaultMapOptions = {
  chart: {
    map: 'countries/us/us-all',
  },
  plotOptions: {
    series: {
      allowPointSelect: true, //Maps
    },
  },
  data: {
    csv: DefaultData.choropleth.data,
    seriesMapping: DefaultData.choropleth.seriesMapping,
  },
};
